module.exports = __webpack_public_path__ + "static/img/project.e7d85cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/project.png
// module id = uAkD
// module chunks = 1